import { PaymentType } from './basket-item.types';

export interface CoverPaymentTypeFee {
  paymentType: PaymentType;
  fee: number;
}
